import React from 'react';
import classes from "./styles/privacy.module.css";
import { Helmet } from 'react-helmet';

const Privacy = () => {

    document.title = "Privacy Policy & Terms | Get Fit With Susmita";

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Privacy Policy & Terms | Get Fit With Susmita</title>
        <meta name="description" content="Read the complete terms, privacy practices, refund policies, and media consent guidelines for Get Fit With Susmita. Understand your rights, responsibilities, and our data usage commitments before enrolling in any program." />
      </Helmet>
      <div className={classes.innerCon}>
        <h1>Terms & Privacy</h1>
        <h6><span>Website:</span> <a href="/">www.getfitwithsusmita.com</a></h6>
        <h6><span>Effective Date:</span> 7th May 2025 </h6>

        <h2>1. Terms & Conditions</h2>
        <p>By enrolling in any program, course, or service offered by Get Fit With Susmita, may or may not be published on the website, you agree to abide by the terms below. Please read them carefully before engaging in any of our offerings.</p>

        <h3>1.1. Voluntary Participation and Assumption of Risk</h3>
        <ul>
            <li>You acknowledge that all fitness training, wellness consultations, and nutrition guidance involve physical exertion and lifestyle changes. </li>
            <li>You agree to participate voluntarily and accept all risks associated with such programs, including but not limited to injury, illness, or adverse physical reactions.</li>
            <li>You confirm that you are medically and physically fit to participate.</li>
            <li>You waive and release Get Fit With Susmita and its associates from any legal claims arising from your participation.</li>
        </ul>

        <h3>1.2. Payment and Enrollment </h3>
        <ul>
            <li>100% advance payment is required to confirm enrollment in any program or session.</li>
            <li>No service will be rendered without payment confirmation.</li>
            <li>Fees are subject to revision with advance notice. Payment can be made via bank transfer or online gateway available on our website. </li>
        </ul>

        <h3>1.3. Client Conduct and Responsibility</h3>
        <ul>
            <li>You are responsible for ensuring internet access, power, appropriate space, and equipment (if applicable) for online sessions. </li>
            <li>Clients must join sessions on time; late entries may not be permitted.</li>
            <li>Participation is always at the client’s discretion and risk. </li>
        </ul>

        <h3>1.4. Rescheduling and Attendance</h3>
        <ul>
            <li>Sessions can only be rescheduled for genuine emergencies and require at least <b>24 hours’ prior notice.</b></li>
            <li>Rescheduled sessions must be completed within the same calendar month as per mutually available time slots only.</li>
            <li>No-shows or cancellations without notice (other than acceptable emergencies) will be counted as completed sessions.</li>
        </ul>

        <h3>1.5. Ownership and Intellectual Property</h3>
        <ul>
            <li>All content provided—including videos, routines, plans, and materials—are the intellectual property of Get Fit With Susmita.</li>
            <li>You may not reuse, share, or reproduce this content without written permission.</li>
        </ul>

        <h3>1.6. Media Consent</h3>
        <ul>
            <li>You grant permission to use photographs, videos, or audio from sessions for promotional and training purposes, unless explicitly opted out in writing prior to participation. You may also request to hide/blur your face before we release your content to general public. </li>
        </ul>

        <h3>1.7. Modification of Terms</h3>
        <ul>
            <li>We reserve the right to update these Terms periodically. Any changes will be posted on our website, and continued use implies acceptance.</li>
        </ul>

        <h3>1.8. Legal Jurisdiction</h3>
        <ul>
            <li>Any disputes shall be subject to arbitration under the <b>Arbitration and Conciliation Act, 1996</b>, in <b>Bhopal, Madhya Pradesh</b>, India.</li>
            <li>Indian law shall govern all matters, and jurisdiction lies exclusively with the courts of Bhopal.</li>
        </ul>

        <h2>2. Privacy Policy </h2>

        <h3>2.1. What We Collect</h3>
        <p>We may collect and store the following data when you enroll:</p>
        <ul>
            <li>Name, age, and contact details </li>
            <li>Medical or health history</li>
            <li>Fitness goals and lifestyle habits</li>
            <li>Performance tracking, journals etc</li>
        </ul>

        <h3>2.2. Purpose of Collection</h3>
        <p>The information is used strictly to:</p>
        <ul>
            <li>Personalize training and nutrition programs</li>
            <li>Communicate session details and progress</li>
            <li>Improve quality of service</li>
        </ul>

        <h3>2.3. Confidentiality and Storage</h3>
        <ul>
            <li>Your personal information will never be shared or sold to third parties.</li>
            <li>Sessions may be recorded for internal training and promotional use. To opt out, write to us in advance.</li>
        </ul>

        <h3>2.4. Data Consent</h3>
        <p>By using our services, you consent to this collection and agree to our usage practices as stated.</p>

        <h2>3. Refund Policy</h2>

        <h3>3.1. No Refund Clause</h3>
        <p>All payments made to Get Fit With Susmita are <b>non-refundable</b>, irrespective of circumstances, including:</p>
        <ul>
            <li>Client dissatisfaction</li>
            <li>Scheduling conflicts</li>
            <li>Missed sessions</li>
            <li>Technical issues from the client’s end</li>
            <li>Changes in personal commitments or health conditions</li>
        </ul>

        <h3>3.2. Applicability</h3>
        <p>This policy applies to all programs and offerings, including:</p>
        <ul>
            <li>Group classes</li>
            <li>One-on-one coaching</li>
            <li>Wellness consultations</li>
            <li>Webinars, workshops, or free trials</li>
        </ul>
        <p>Please ensure you fully understand the program details before enrolling. If in doubt, contact us via the details below. </p>

        <h2>4. Disclaimer on Guarantees & Outcomes </h2>
        <p>At Get Fit With Susmita, our goal is to support, guide, and empower you on your fitness and wellness journey through structured programs and professional coaching.</p>
        <p>However, we do <b>not guarantee</b> any specific results, outcomes, weight loss, muscle gain, or health improvements. The success of any program depends on several individual factors, including but not limited to:</p>
        <ul>
            <li>Your commitment and consistency</li>
            <li>Your current health condition</li>
            <li>Your lifestyle choices outside of the sessions</li>
            <li>Your adherence to recommended plans </li>
        </ul>
        <p>While we strive to provide you with the best possible tools, guidance, and motivation, <b>the responsibility for applying them and achieving results lies entirely with you.</b></p>
        <p>No claims, verbal or written, should be interpreted as a promise of results.</p>

        <h2>5. Media Content & Marketing Usage</h2>
        <p>By participating in Get Fit With Susmita programs (online or offline), you consent to the possibility of being recorded, photographed, or featured in content created during live sessions, classes, or events. These recordings may be used for:</p>
        <ul>
            <li>Marketing campaigns (online and offline)</li>
            <li>Social media content</li>
            <li>Educational material</li>
            <li>Testimonials or case studies</li>
        </ul>
        <p>If you <b>do not wish to be featured</b>, you must notify us <b>in writing via email</b> before the session. We will take reasonable steps to exclude your visuals and voice from future use. You may also request us to keep your face hidden/blurred before we relate the content to general public. </p>

        <h2>6. Indemnification Clause</h2>
        <p>You agree to <b>indemnify, defend, and hold harmless</b> Get Fit With Susmita, its founders, team members, associates, and partners from and against any claims, demands, losses, liabilities, damages, or expenses (including legal fees) arising out of: </p>
        <ul>
            <li>Your participation in any program or session</li>
            <li>Violation of these Terms</li>
            <li>Use or misuse of the services provided</li>
            <li>Misrepresentation of your physical or medical condition</li>
        </ul>
        <p>This clause remains applicable even after your program ends.</p>

        <h2>7. Governing Law & Bhopal Jurisdiction </h2>
        <p>All services, agreements, and disputes related to Get Fit With Susmita are governed by the laws of the <b>Republic of India.</b></p>
        <p>In the event of any legal dispute, claim, or disagreement, the matter shall be:</p>
        <ul>
            <li>Resolved through arbitration as per the <b>Arbitration and Conciliation Act, 1996</b></li>
            <li>Conducted in <b>English language</b></li>
            <li>Heard exclusively in <b>Bhopal, Madhya Pradesh</b>, which shall have sole jurisdiction over such matters</li>
        </ul>

        <h2>8. Contact Us </h2>
        <p>If you have any questions, clarifications, or would like to opt out of certain policies (such as media consent), please write to us at:</p>
        <p><b>Contact details and Email:</b> As mentioned on the website</p>
        <p>We aim to respond to all queries within 4-5 working days.</p>
        <p><b>By enrolling in any service from Get Fit With Susmita, you acknowledge that you have read, understood, and accepted all terms outlined in this document.</b></p>
      </div>
    </div>
  )
}

export default Privacy
